import { MenuCategory } from '../types';
import { isNewMenuCategory } from '../utils';

export const getIdForCategory = (menuCategory: MenuCategory): string => {
  return isNewMenuCategory(menuCategory) ? menuCategory.tempId : menuCategory.id;
};
